import { VectorProps } from './types';

const X = ({ className, size = 1, color = 'currentColor' }: VectorProps) => (
  <svg className={className} width={`${size}em`} viewBox="0 0 24 24">
    <path
      fill={color}
      d="m19.8 5.8-1.6-1.6-6.2 6.2-6.2-6.2-1.6 1.6 6.2 6.2-6.2 6.2 1.6 1.6 6.2-6.2 6.2 6.2 1.6-1.6-6.2-6.2 6.2-6.2z"
    />
  </svg>
);

export default X;
